/** @jsx jsx */
import { css } from "@emotion/react";

export const formacaoQuePrepara = css`
  background-color: #FFFFFF;
  padding: 120px 0;
  scroll-margin-top: 70px;

  .title-sec {
    margin-bottom: 56px;
    h2 {
      color: #3C3C3C;
      font-family: Montserrat;
      font-size: 32px;
      font-style: normal;
      font-weight: 500;
      line-height: 120%;
      width: 100%;
      max-width: 526px;
      span {
        color: #F26F33;
        font-weight: 600;
      }
    }

    p {
      color: #686868;
      font-family: Montserrat;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
      margin-bottom: 0px;
    }
  }
  .box-1 {
    border-radius: 56px;
    background: #DAE7DC;
    padding: 48px;
    img {
      margin-bottom: 48px;
    }
    h3 {
      color: #3C3C3C;
      font-family: Montserrat;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: 120%;
      height: 48px;
      width: 100%;
      max-width: 200px;
    }
    p {
      color: #686868;
      font-family: Montserrat;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
      height: 98px;
    }
  }
  .box-2 {
    border-radius: 56px;
    background: #FFE8DD;
    padding: 48px;
    img {
      margin-bottom: 48px;
    }
    h3 {
      color: #3C3C3C;
      font-family: Montserrat;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: 120%;
      height: 48px;
      width: 100%;
      max-width: 200px;
    }
    p {
      color: #686868;
      font-family: Montserrat;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
      height: 98px;
    }
  }

  @media only screen and (max-width: 600px) {
    padding: 60px 0;
    .box-2 {
        margin-top: 24px;
        margin-bottom: 24px;
      }  
    }
`
